import PropTypes from 'prop-types';
import React from 'react';
import Spinner from './Spinner';

/**
 * Results presentational component
 * Shows spinner during loading, results after loading or error message on server error
 * or when no results found
 */
export default function Results({ children, itemsNum, fetching, error }) {
    if (fetching) {
        return <Spinner />;
    }

    if (!itemsNum) {
        return (
            <span className="search-resultMessage">
                {error
                    ? 'There was a problem with the search'
                    : 'No matches were found'
                }
            </span>
        );
    }

    return children;
}

Results.propTypes = {
    /**
     * Results node
     */
    children: PropTypes.node,
    /**
     * Count of items found
     */
    itemsNum: PropTypes.number,
    /**
     * Flag to show spinner
     */
    fetching: PropTypes.bool,
    /**
     * Error object
     */
    error: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

Results.defaultProps = {
    children: null,
    itemsNum: 0,
    fetching: false,
    error: null,
};



// WEBPACK FOOTER //
// ./src/js/Common/Results.jsx